/**
 * Author: Stefan Haack (https://shaack.com)
 */

export const PLAYER_STATE = {
    idle: "idle",
    linkGame : "linkGame",
    // appInit: "appInit",
    lobbyGameRequestSent: "lobbyGameRequestSent",
    initGameReceived: "initGameReceived",
    playing: "playing",
    puzzle: "puzzle"
}

export class ChessConsoleAppState {
    constructor() {
        this.playerColor = undefined
        this.playerState = PLAYER_STATE.idle
        this.opponentName = undefined
        this.gameState = {
            _pregameAbort: {
                black: {
                    firstMoveMade: undefined
                },
                white: {
                    firstMoveMade: undefined
                }
            },
            _resignState: {
                black: undefined,
                    white: undefined
            },
            _blackid: undefined,
                _whiteid: undefined,
                _black_name: undefined,
                _move_time: [],
                _white_name: undefined,
                _centiPawnScore: {
                black: undefined,
                    white: undefined
            },
            _outcome: {
                _user: {
                    abort: undefined,
                    balance: undefined,
                    balance_delta: undefined,
                    currency_glyph: undefined,
                    currency_iso: undefined,
                    elo: undefined,
                    elo_delta: undefined,
                    old_balance: undefined,
                    old_elo: undefined
                },
                _opponent: {
                    elo: undefined,
                        old_elo: undefined
                },
                _isDraw: undefined,
                    _winnerUID: undefined,
                    _loserUID: undefined,
                    _endOfGameMessage: undefined,
                    _rematchState: {
                        _opp_online: undefined,
                        _opp_rematch: undefined,
                        _rematch_sent: undefined
                }
            },
            _colorToPlay: undefined,
                _clock: {
                black: undefined,
                    white: undefined
            },
            _fenList: [],
                _uciMoves: [],
                _connection: {
                black: {
                    connected: undefined
                },
                white: {
                    connected: undefined
                }
            },
            _drawState: {
                black: undefined,
                    white: undefined
            },
            _drawSpinners: {
                black: undefined,
                    white: undefined
            },
            _check: {
                chblack: undefined,
                    chwhite: undefined
            },
            _uuid: undefined
        }
        this.initGameData = {
            blackRating: undefined,
                blackUID: undefined,
                pregame_count: undefined,
                stake: undefined,
                stake_string: undefined,
                time_control_string: undefined,
                timectl: undefined,
                whiteRating: undefined,
                whiteUID: undefined
        }
    }
}
